import { takeEvery, takeLatest } from 'redux-saga';
import { call, put } from 'redux-saga/effects';
import alertify from 'alertify.js';
import ReactGA from 'react-ga';
import { browserHistory } from 'react-router';

import { fetchApiAuth } from '../utils/api';

import {
    getProfileSuccess,
    getProfileFailure,

    profileUpdateSuccess,
    profileUpdateFailure,

    addUsersCsvSuccess,
    addUsersCsvFailure,

    inviteUsersSuccess,
    inviteUsersFailure
} from './profileActions';

const {
    GET_PROFILE_REQUEST,
    PROFILE_UPDATE_REQUEST,
    ADD_USERS_CSV_REQUEST,
    INVITE_USERS_REQUEST
} = require('./profileActions').constants;

/**
 * Get current user profile
 **/
function* fetchProfile() {
    try {
        const response = yield call(fetchApiAuth, {
            method: 'GET',
            url: '/user/view',
            params: { expand: 'profile' }
        });

        // redirect to not verified page
        if (response.data.school !== null && response.data.role === 'senior') {
            if (response.data.school.status === 'rejected') {
                browserHistory.push('/school-rejected');
            } else if (response.data.school.status === 'pending') {
                browserHistory.push('/school-pending');
            }
        }
        // if email not verified
        if (response.data.status === 'not-active') {
            browserHistory.push('/not-active');
        }

        // log analytics
        ReactGA.set({ userId: response.data.id });

        yield put(getProfileSuccess(response));
    } catch (e) {
        yield put(getProfileFailure(e.response ? e.response.data.message : e));

        // redirect to login page
        // browserHistory.push('/login');
    }
}

/**
 * update current users profile
 */
function* updateProfile(action) {
    try {
        const response = yield call(fetchApiAuth, {
            method: 'PUT',
            url: '/user/update',
            body: action.payload
        });

        yield put(profileUpdateSuccess(response));
        alertify.success('Profile updated successfully');
    } catch (e) {
        yield put(profileUpdateFailure(e.response ? e.response.data.message : e));
    }
}

/**
 * upload csv of users and add them to current school
 */
function* addUsersCsv(action) {
    try {
        const response = yield call(fetchApiAuth, {
            method: 'POST',
            url: '/school/add-users-csv',
            body: action.payload
        });

        yield put(addUsersCsvSuccess(response));
        let alertData = `${response.data.successfully_imported} users imported successfully. `;
        alertData += response.data.exists_email.length > 0 ? `${response.data.exists_email.length} users already had account.` : '';
        alertify.alert(alertData);
    } catch (e) {
        yield put(addUsersCsvFailure(e.response ? e.response.data.message : e));
    }
}

/**
 * invite users via email
 */
function* inviteUsers(action) {
    try {
        const response = yield call(fetchApiAuth, {
            method: 'POST',
            url: '/user/invite',
            body: action.payload
        });

        yield put(inviteUsersSuccess(response));
        alertify.alert('Users invited successfully.');
    } catch (e) {
        alertify.alert(e.response ? e.response.data.message : e);
        yield put(inviteUsersFailure(e.response ? e.response.data.message : e));
    }
}

/**
 * Watch actions
 */
export default function* profileSaga() {
    yield* [
        takeLatest(GET_PROFILE_REQUEST, fetchProfile),
        takeEvery(PROFILE_UPDATE_REQUEST, updateProfile),
        takeLatest(ADD_USERS_CSV_REQUEST, addUsersCsv),
        takeLatest(INVITE_USERS_REQUEST, inviteUsers)
    ];
}



/** WEBPACK FOOTER **
 ** ./src/core/profile/profileSaga.js
 **/